export interface PhotonSearchResult {
  type: 'Feature';
  properties: {
    osm_type: string;
    osm_id: number;
    osm_key: string;
    osm_value: string;
    type: string;
    postcode?: string;
    countrycode: string;
    name: string;
    country: string;
    city?: string;
    district?: string;
    locality?: string;
    street?: string;
    state?: string;
    county?: string;
    housenumber?: string;
    extent?: [number, number, number, number];
  };
  geometry: {
    type: 'Point';
    coordinates: [number, number]; // [longitude, latitude]
  };
}

export interface PhotonSearchResponse {
  type: 'FeatureCollection';
  features: PhotonSearchResult[];
}

export class PhotonSearchService {
  private static readonly BASE_URL = 'https://photon.komoot.io/api/';

  static async search(query: string): Promise<PhotonSearchResult[]> {
    if (!query.trim()) return [];

    try {
      const response = await fetch(
        `${this.BASE_URL}?q=${encodeURIComponent(query.trim())}`
      );

      if (!response.ok) {
        throw new Error(`Search failed: ${response.status}`);
      }

      const data: PhotonSearchResponse = await response.json();
      return data.features || [];
    } catch (error) {
      console.error('Photon search error:', error);
      return [];
    }
  }

  static formatSearchResult(result: PhotonSearchResult): string {
    const { name, city, state, country } = result.properties;

    const parts = [name];
    if (city && city !== name) parts.push(city);
    if (state && state !== city) parts.push(state);
    if (country) parts.push(country);

    return parts.join(', ');
  }
}
